<template>
<transition name="modal">
<div id="modal" class="modal">
  <div class="modal__wrap">
    <div class="modal__wrap__card">
      <header class="modal__wrap__card__header">
         <div class="modal__wrap__card__header__icn">
           <img src="@/assets/images/modal/modal-icn-sync.svg" alt="Sync">
          </div>
          {{ title[target] }}
      </header>
      <div class="modal__wrap__card__content">
        <p>{{ description[target] }}</p>
        <div class="circle" :class="{'active': isTimerAnimation}" v-if="target == 'sp'">
          <div class="circle-inner">
          <dl class="circle-inner__password">
            <dt>Password</dt>
            <dd>{{ oneTimePassword }}</dd>
          </dl>
          <p class="circle-inner__limit">残り<strong>{{ oneTimeCount }}</strong>秒</p>
          </div>
        </div>
        <figure class="modal__wrap__card__content__qr" v-if="target == 'mirror'">
          <canvas id="QRCode"></canvas>
        </figure>
        <div class="modal__wrap__card__content__customid">カスタムID : <span>{{ customID }}</span></div>

      </div>
      <div class="modal__wrap__card__close" @click="closeModal">
        <img src="@/assets/images/custom/custom-close.svg" alt="Close" />
      </div>
    </div>
  </div>
  <div class="modal__background"></div>
</div>
</transition>
</template>

<script>
import QRCode from 'qrcode'
import {config} from '@/config.js'
import { setInterval, clearInterval, setTimeout } from 'timers'
import customMgr from '@/modules/CustomManager.js'

const oneTImeCountLimit = 20

export default {
  data () {
    return {
      oneTimeCount: oneTImeCountLimit,
      oneTimePassword: '',
      isTimerAnimation: true,
      baseURL: {
        'sp': config['appURL'] + '/mirror/custom',
        'mirror': config['appURL'] + '/custom'
      },
      title: {
        'sp': 'スマートミラーに送る',
        'mirror': 'スマートフォンに保存する'
      },
      description: {
        'sp': '阪急うめだ店1階では、下記のカスタムIDをスマートミラーで入力すると、カスタムした商品を鏡に映し出してデザインをご確認頂くことができます。スマートミラーについての詳細は店舗スタッフ、または当サイト内のHOW TO USEをご覧ください。',
        'mirror': 'スマートミラーのデータをお手持ちのスマートフォンに移して編集することができます。QRコードを読み取る、またはカスタムIDを入力してデータを移行してください。'
      }
    }
  },
  props: {
    target: String,
    customImage: String,
    customID: String
  },
  created () {
    window.addEventListener('visibilitychange', () => {
      this.closeModal()
    })
  },
  mounted () {
    let isSignage = false
    if (this.target === 'sp') isSignage = true
    const url = `${this.baseURL[this.target]}?customid=${this.customID}&signage=${isSignage}`

    if (this.target === 'mirror') {
      QRCode.toCanvas(
        this.$el.querySelector('#QRCode'),
        url,
        { errorCorrectionLevel: 'H' }, (error) => {
          if (error) console.error(error)
        }
      )
    } else {
      this.initOneTimePassword()
    }
  },
  methods: {
    closeModal () {
      this.stopOneTimePassword()
      customMgr.removeOneTimePasswordData().then(() => {
        this.$emit('close')
      })
    },
    getOneTimePassword () {
      const l = 4
      const c = '0123456789'
      const cl = c.length
      let r = ''
      for (let i = 0; i < l; i++) {
        r += c[Math.floor(Math.random() * cl)]
      }
      return r
    },
    startOneTimePassword () {
      this.oneTimePasswordTimer = setInterval(() => {
        if (this.oneTimeCount <= 0) {
          this.initOneTimePassword()
        } else {
          this.oneTimeCount -= 1
        }
      }, 1000)
    },
    initOneTimePassword () {
      this.stopOneTimePassword()
      this.isTimerAnimation = false
      this.oneTimePassword = this.getOneTimePassword()

      customMgr.getOneTimePasswordData().then((allData) => {
        let isMatch = false
        // ワンタイムパスワードデータを全て取得してチェック
        for (const key in allData) {
          if (allData.hasOwnProperty(key)) {
            const element = allData[key]
            if (element['password'] === this.oneTimePassword) {
              isMatch = true
              break
            }
          }
        }

        // ワンタイムパスワードが重複しなかった場合、Timerを実行
        if (!isMatch) {
          customMgr.setOneTimePasswordData(
            this.customID,
            this.oneTimePassword
          ).then(() => {
            setTimeout(() => {
              this.oneTimeCount = oneTImeCountLimit
              this.isTimerAnimation = true
              this.startOneTimePassword()
            }, 100)
          })
        } else {
          this.initOneTimePassword()
        }
      })
    },
    stopOneTimePassword () {
      clearInterval(this.oneTimePasswordTimer)
    }
  }
}
</script>
<style lang="scss" scoped>
.circle {
  position: relative;
  width: 180px;
  height: 180px;
  background: #333;
  border-radius: 50%;
  text-align: center;
  overflow: hidden;
  margin: 20px auto;
  z-index: 1;

  &::before {
    content: "";
    display: block;
    position: absolute;
    top: 0;
    left: -90px;
    width: 180px;
    height: 180px;
    background: $gray;
    transform-origin: right 90px;
    z-index: 2;
  }
  &::after {
    content: "";
    display: block;
    position: absolute;
    top: 0px;
    left: 90px;
    width: 180px;
    height: 180px;
    background: $gray;
    transform-origin: left 90px;
    z-index: 3;
  }
  &.active {
    &::before {
      animation: rotate-circle-left 21s linear forwards;
    }
    &::after {
      animation: rotate-circle-right 21s linear forwards;
    }
  }
  .circle-inner {
    position: absolute;
    top: 20px;
    left: 20px;
    width: 140px;
    height: 140px;
    padding-top: 35px;
    background: #fff;
    border-radius: 50%;
    z-index: 4;

    &__password {
      font-weight: bold;
      line-height: 1.0;
      margin-bottom: 5px;

      dt {
        font-size: 13px;
        margin-bottom: 5px;
      }
      dd {
        font-size: 32px;
      }
    }

    &__limit {
      font-weight: bold;
      font-size: 13px;
    }
  }
}

@keyframes rotate-circle-right {
  0%  {
    transform: rotate(0deg);
    background: $gray;
  }
  50%  {
    transform: rotate(180deg);
    background: $gray;
  }
  50.01% {
    transform: rotate(360deg);
    background: #333;
  }
  100% {
    transform: rotate(360deg);
    background: #333;
  }
}

@keyframes rotate-circle-left {
  0%   { transform: rotate(0deg); }
  50%  { transform: rotate(0deg); }
  100% { transform: rotate(180deg); }
}
</style>



// WEBPACK FOOTER //
// src/components/SyncModal.vue